type Props = {
  color: string;
};

const ProfileIcon = ({ color }: Props) => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      xmlns="http://www.w3.org/2000/svg"
      id="login"
      fill="#56BD6F"
    >
      <g id="HEADER" transform="translate(-283.000000, -30.000000)">
        <g>
          <g
            id="Icon_x2F_Nav_x2F_Profile_x2F_Active"
            transform="translate(279.000000, 26.000000)"
          >
            <g id="profile">
              <g id="head">
                <path
                  fill={color}
                  d="M12,12c-2.206,0-4-1.794-4-4s1.794-4,4-4c2.206,0,4,1.794,4,4S14.206,12,12,12z M12,6 c-1.103,0-2,0.897-2,2s0.897,2,2,2c1.103,0,2-0.897,2-2S13.103,6,12,6z"
                ></path>
              </g>
              <g id="bust">
                <path
                  fill={color}
                  d="M20,21H4v-1c0-3.859,3.14-7,7-7h2c3.859,0,7,3.141,7,7V21z M6.101,19h11.799 c-0.465-2.279-2.484-4-4.899-4h-2C8.585,15,6.565,16.721,6.101,19z"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default ProfileIcon;
